import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSecretPhrase: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSecretPhrase"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM6 8H11V9.5H6V8ZM13 8V9.5H18V8H13ZM6 11.25H11V12.75H6V11.25ZM13 11.25V12.75H18V11.25H13ZM6 14.5H11V16H6V14.5ZM13 14.5V16H18V14.5H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSecretPhrase;
